import {IPoi} from "../types/IPoi";

export const getNearestPoiDistance = (pois: IPoi[]) => (pois.length ? Math.round(Math.min(...pois.map((poi) => poi.distance))) : null);
import {IPoi} from "../types/IPoi";

export const getNearestPoiDistance = (pois: IPoi[]) => (pois.length ? Math.round(Math.min(...pois.map((poi) => poi.distance))) : null);
